import { render } from "./CategoryTreeComponent.vue?vue&type=template&id=7d2dacb6"
import script from "./CategoryTreeComponent.vue?vue&type=script&lang=js"
export * from "./CategoryTreeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__